var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarbonSecurity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 20.7375L14.2625 17.5L12.5 19.2625L17.5 24.2625L27.5 14.2625L25.7375 12.5L17.5 20.7375Z",
    fill: "#FF6600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 37.5L12.28 33.3838C10.079 32.2131 8.23839 30.4651 6.9558 28.3274C5.67321 26.1896 4.99709 23.743 5.00001 21.25V5C5.00001 4.33696 5.2634 3.70107 5.73224 3.23223C6.20108 2.76339 6.83697 2.5 7.50001 2.5H32.5C33.1631 2.5 33.7989 2.76339 34.2678 3.23223C34.7366 3.70107 35 4.33696 35 5V21.25C35.0029 23.743 34.3268 26.1896 33.0442 28.3274C31.7616 30.4651 29.921 32.2131 27.72 33.3838L20 37.5ZM7.50001 5V21.25C7.49862 23.2896 8.05236 25.2912 9.10186 27.04C10.1514 28.7889 11.6571 30.2192 13.4575 31.1775L20 34.6662L26.5425 31.1788C28.3432 30.2203 29.849 28.7899 30.8985 27.0407C31.948 25.2916 32.5016 23.2898 32.5 21.25V5H7.50001Z",
    fill: "#FF6600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonSecurity);
export default __webpack_public_path__ + "static/media/carbon_security.b5d7dcea7558b1d5a6f595baabd9b354.svg";
export { ForwardRef as ReactComponent };